import {
  OutputFormat,
  SetCheckedItems,
  setOutputFormat,
} from "pages/geoscape-batch/models";
import { useMemo } from "react";

import CustomTable from "components/shared/table";
import { BatchConfigProps } from "pages/geoscape-batch/types";
import { buildColumns } from "./columns-row";

type Props = {
  props: BatchConfigProps;
  setCheckedItems: SetCheckedItems;
  enrichmentRows: OutputFormat[];
  setEnrichmentRows: setOutputFormat;
};

const MappingTableEnrichment = ({
  setCheckedItems,
  enrichmentRows,
  setEnrichmentRows,
}: Props) => {
  const columns = useMemo(
    () => buildColumns({ setEnrichmentRows, setCheckedItems }),
    [setEnrichmentRows, setCheckedItems],
  );

  return (
    <div className="flex flex-col items-center w-full h-full mt-4">
      {enrichmentRows && (
        <CustomTable
          rows={enrichmentRows}
          columns={columns}
          isLoading={false}
          getRowId={(row: OutputFormat) => `${row.property}-${row.attributeName}`}
          pagination={false}
          overlayText=""
        />
      )}
    </div>
  );
};

export default MappingTableEnrichment;
